type Vec3 = { x: number; y: number; z: number }
type AttachmentSpec = { dimensions: Vec3; offset: Vec3 }

type ShelfHeightConfig = {
  h43 : AttachmentSpec
  h70 : AttachmentSpec
  h100? : AttachmentSpec
}

// Positive offsetX stored here; addVirtualMeshesToUnt negates it for right-side corners.
type CornerHeightConfig = {
  h43 : { dimensions: Vec3; offsetX: number; offsetY: number; offsetZ: number }
  h70 : { dimensions: Vec3; offsetX: number; offsetY: number; offsetZ: number }
  h100? : { dimensions: Vec3; offsetX: number; offsetY: number; offsetZ: number }
}

export type VirtualMeshDimensionConfig = {
  shelf : { w43: ShelfHeightConfig; w70: ShelfHeightConfig }
  corner : CornerHeightConfig
}

export const MMS_VIRTUAL_MESH_CONFIG: VirtualMeshDimensionConfig = {
  shelf: {
    w43: {
      h43  : { dimensions: { x: 1.2, y: 1.0, z: 0.8 }, offset: { x: 0, y: -0.2, z: 0 } },
      h70  : { dimensions: { x: 1.2, y: 1.75, z: 0.8 }, offset: { x: 0, y: 0.25, z: 0 } },
      h100 : { dimensions: { x: 1.2, y: 2.55, z: 0.8 }, offset: { x: 0, y: 0.55, z: 0 } },
    },
    w70: {
      h43  : { dimensions: { x: 1.85, y: 1.1, z: 0.8 }, offset: { x: -0.01, y: -0.05, z: 0.15 } },
      h70  : { dimensions: { x: 1.85, y: 1.85, z: 0.8 }, offset: { x: -0.02, y: 0.35, z: 0.15 } },
      h100 : { dimensions: { x: 1.85, y: 2.55, z: 0.8 }, offset: { x: 0, y: 0.55, z: 0.15 } },
    },
  },
  corner: {
    h43  : { dimensions: { x: 1, y: 1.3, z: 1 }, offsetX: 0.65, offsetY: 0.65, offsetZ: 0 },
    h70  : { dimensions: { x: 1, y: 1.75, z: 1 }, offsetX: 0.65, offsetY: 0.85, offsetZ: 0 },
    h100 : { dimensions: { x: 1, y: 2.55, z: 1 }, offsetX: 0.65, offsetY: 1.25, offsetZ: 0 },
  },
}
